export const LoginData = [

    {
        id: 0,
        email: 'joshhooah@gmail.com',
        password: 12345678
    }
]